import React, { useMemo } from 'react';
import Row from '@amzn/meridian/row';
import Column from '@amzn/meridian/column';
import { useGet, useClient, Build } from '$/api';
import { CorePage, CorePageTitle, CoreSearchTable } from '$/components';
import {
  CoreTabGroupSwitch,
  CoreTabRoute,
  ListResponse,
} from '@amzn/dots-core-ui';

import { useQuery } from 'react-query';
import { useIdParam } from '$/hooks';
import Text from '@amzn/meridian/text';
import Link from '@amzn/meridian/link';
import { BuildVersionList, ProjectColumnDefinitions } from './components';
import { ProjectUri, RootUri } from '../routes';

const filters = [
  { key: 'name', label: 'Name', isDefault: true },
  { key: 'id', label: 'ID' },
];

export const ProjectDetailPage = (): JSX.Element => {
  const id = useIdParam();
  const { projects } = useClient();
  const { data: project } = useGet(projects.resourceKey, projects.get, id);
  const queryKey = useMemo(
    () => ['buildVersion', project?.name],
    [project?.name]
  );
  const { isError, isLoading, error } = useQuery<ListResponse<Build>, Error>(
    queryKey,
    () => projects.getVersions(project ? project.name : 'bla')
  );

  return (
    <CorePage
      title={project?.name ? project.name : `${id}`}
      isLoading={isLoading}
      isError={isError}
      error={error}
      breadcrumbs={[
        { title: 'Storage', href: RootUri },
        { title: 'Projects', href: ProjectUri },
      ]}
      header={
        <>
          <Column spacing="400">
            {project?.name && <CorePageTitle title={project?.name} />}
            <Column spacing="100">
              <Row>
                <Text>Product Family: </Text>
                <Link href="https://meridian.a2z.com/">product family</Link>
              </Row>
              <Row>
                <Text>Product: </Text>
                <Link href="https://meridian.a2z.com/">product</Link>
              </Row>
            </Column>
          </Column>
        </>
      }
    >
      <CoreTabGroupSwitch>
        <CoreTabRoute label="Versions" path="versions">
          {project && <BuildVersionList project={project} />}
        </CoreTabRoute>
        <CoreTabRoute label="Admin" path="admin">
          <CoreSearchTable
            resourceKey={projects.resourceKey}
            getAll={projects.getAll}
            resourceFilters={filters}
            columns={ProjectColumnDefinitions}
          />
        </CoreTabRoute>
      </CoreTabGroupSwitch>
    </CorePage>
  );
};
